import React from "react";
import QuoteForm from "@/components/QuoteForm";
import { Phone, Truck, Package, Wrench, MapPin } from "lucide-react";

export default function Logistics() {
  return (
    <div data-testid="logistics-page">
      <section className="hb-hero-frame text-white py-24">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="text-xs tracking-[0.35em] uppercase text-white/60 mb-4">Hampton Blu Creations · A Division of</div>
          <h1 className="font-display text-6xl sm:text-7xl">Hampton Blu Logistics</h1>
          <p className="mt-6 text-2xl font-serif-editorial italic text-white/90">Moving Your Business Forward, the Right Way.</p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 py-16">
        <p className="text-lg leading-relaxed text-neutral-800">
          Hampton Blu Logistics provides dependable transportation and logistics solutions for individuals and businesses. Whether you need equipment moved, freight transported, delivery assistance, trailer hauling, or other logistics services, we're committed to providing safe, efficient, and professional service.
        </p>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            {icon: Truck, t: "Freight & Transport"},
            {icon: Package, t: "Delivery Assistance"},
            {icon: Wrench, t: "Equipment Moves"},
            {icon: MapPin, t: "Trailer Hauling"},
          ].map(({icon: Icon, t}) => (
            <div key={t} className="bg-white border border-neutral-200 p-6 text-center">
              <Icon size={28} className="mx-auto mb-3 text-[color:var(--hb-royal)]"/>
              <div className="text-sm font-medium">{t}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-6 pb-24">
        <div className="mb-6">
          <div className="text-xs tracking-widest uppercase text-neutral-500 mb-2">Get in touch</div>
          <h2 className="font-display text-4xl text-[color:var(--hb-navy)]">Request a Logistics Quote</h2>
          <p className="mt-3 text-neutral-700">
            For all logistics, transportation, moving, hauling, or equipment inquiries, please contact <b>Greg</b> at{" "}
            <a href="tel:6316722715" className="underline inline-flex items-center gap-1"><Phone size={14}/> 631-672-2715</a>{" "}
            or use the form below.
          </p>
        </div>
        <QuoteForm
          serviceType="logistics"
          contactPerson="Greg"
          contactPhone="631-672-2715"
          defaultServiceOptions={[
            "Freight Transport","Delivery Assistance","Equipment Move",
            "Trailer Hauling","Local Moving","Other"
          ]}
        />
      </section>
    </div>
  );
}
